//#region Asset Imports

import './button-list.scss'
import * as TEMPLATE from './button-list.tpl.html'

//#endregion

import { ButtonListController, ButtonListOptions } from './button-list.directive.controller'

export { ButtonListOptions }

export class ButtonListDirective implements ng.IDirective {
    scope = {
        "options": "="
    }
    restrict = 'E'
    controller = ['$scope', '$timeout', ($scope: any, $timeout: ng.ITimeoutService) => new ButtonListController($scope, $timeout)]
    template = TEMPLATE
    replace = true
}